(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/forms"), require("@angular/common"), require("rxjs/Subject"), require("rxjs/operator/debounceTime"), require("rxjs/operator/map"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/forms", "@angular/common", "rxjs/Subject", "rxjs/operator/debounceTime", "rxjs/operator/map"], factory);
	else if(typeof exports === 'object')
		exports["ng-formly"] = factory(require("@angular/core"), require("@angular/forms"), require("@angular/common"), require("rxjs/Subject"), require("rxjs/operator/debounceTime"), require("rxjs/operator/map"));
	else
		root["ng-formly"] = factory(root["@angular/core"], root["@angular/forms"], root["@angular/common"], root["rxjs/Subject"], root["rxjs/operator/debounceTime"], root["rxjs/operator/map"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_23__, __WEBPACK_EXTERNAL_MODULE_24__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition